import { makeAutoObservable, runInAction } from 'mobx';
import get from 'lodash/get';
import { requestPost } from '../../services/real.backend';

class SearchStorage {
  searchValue = '';

  searchResults = [];

  emptyResult = false;

  searchedId = null;

  constructor() {
    makeAutoObservable(this);
  }

  setSearchValue = (value) => this.searchValue = value;

  clearSearchValue = () => {
    this.searchValue = '';
    this.searchResults = [];
    this.emptyResult = false;
  }

  setSearchResults = (results) => {
    if (!results || results.length === 0) {
      this.emptyResult = true;
      this.searchResults = [];
    } else {
      this.searchResults = results.map((item) => ({ ...item, message: JSON.parse(item.message) }));
      this.emptyResult = false;
    }
  }

  clearSearchResults = () => this.searchResults = [];

  loadSearchResults = () => requestPost('/api/messages/search', {
    searchValue: this.searchValue,
  })
    .then((resp) => {
      const searchResults = get(resp, 'searchResults');
      runInAction(() => {
        if (searchResults) {
          this.setSearchResults(searchResults);
        } else {
          this.emptyResult = true;
        }
      });
    })

  setSearchedId = (id) => {
    this.searchedId = id;
  }
}

const searchStorage = new SearchStorage();

export default searchStorage;
